import React from 'react';
import './CourseUploadGuidelines.css';

const CourseUploadGuidelines = () => {
    return (
        <div className="guidelines-container">
            <div className="guidelines-header">
                <h1>Course Upload Guidelines</h1>
                <p>
                    Follow these guidelines to ensure a smooth upload process and avoid delays or rejections.
                    These steps are designed to help you meet our platform's standards and provide the best experience for learners.
                </p>
            </div>
            <div className="content-section">
                <div >
                     <div className="tip-item">
                        <h3>Ensure Your Course Title and Thumbnail Match</h3>
                        <p>
                            Your course title and thumbnail should accurately represent the content of your course. 
                            If they don't align, your course may be rejected during validation. 
                            Choose a title and thumbnail that are clear, engaging, and consistent.
                        </p>
                    </div>

                     <div className="tip-item">
                        <h3>Match Video Content and Keywords with the Title</h3>
                        <p>
                            Ensure that your video content and audio keywords are aligned with the video title. 
                            Any mismatch might result in the rejection of individual videos. 
                            Plan your content carefully and use precise titles for your videos.
                        </p>
                    </div>

                     <div className="tip-item">
                        <h3>Understand the Upload and Validation Process</h3>
                        <p>
                            Once you click the "Add Course" button, the upload process will begin. 
                            Please wait until the loading completes. If your course passes validation, 
                            you will receive a green success notification, and your course will be sent for review by our team.
                            If validation fails, a red failure notification will appear. Ensure all guidelines are followed, make the necessary corrections, and re-upload for approval.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CourseUploadGuidelines;
